import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCustomerCreateForm } from './hooks';

export const CustomerCreateScreen = () => {
    const navigate = useNavigate();
    const { token } = useSelector((state) => state.auth);

    const {
        isSaving,
        error,
        form,
        handleInputChange,
        handleSubmit,
        handleCancel,
    } = useCustomerCreateForm({
        token,
        navigate,
    });

    return (
        <div className="row">
            <div className="col-12 col-xl-9 col-xxl-8 mx-auto">
                <div className="card card__no-border">
                    <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h5 className="fw-bold mb-0">Nuevo cliente</h5>
                            <button type="button" className="btn btn-light-brand" onClick={handleCancel}>
                                Volver
                            </button>
                        </div>

                        {error && (
                            <div className="alert alert-danger py-2" role="alert">
                                {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <div className="row g-2">
                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="customer-name">Compañía</label>
                                    <input
                                        id="customer-name"
                                        name="name"
                                        type="text"
                                        className="form-control"
                                        value={form.name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="customer-contact-name">Contacto</label>
                                    <input
                                        id="customer-contact-name"
                                        name="contactName"
                                        type="text"
                                        className="form-control"
                                        value={form.contactName}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="customer-contact-email">Email</label>
                                    <input
                                        id="customer-contact-email"
                                        name="contactEmail"
                                        type="email"
                                        className="form-control"
                                        value={form.contactEmail}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="customer-contact-phone">Teléfono</label>
                                    <input
                                        id="customer-contact-phone"
                                        name="contactPhone"
                                        type="text"
                                        className="form-control"
                                        value={form.contactPhone}
                                        onChange={handleInputChange}
                                        minLength={8}
                                        required
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label" htmlFor="customer-join-date">Fecha de alta</label>
                                    <input
                                        id="customer-join-date"
                                        name="joinDate"
                                        type="date"
                                        className="form-control"
                                        value={form.joinDate}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="col-12">
                                    <label className="form-label" htmlFor="customer-description">Descripción</label>
                                    <textarea
                                        id="customer-description"
                                        name="description"
                                        className="form-control"
                                        rows={4}
                                        value={form.description}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-3">
                                <button
                                    type="button"
                                    className="btn btn-light-brand"
                                    onClick={handleCancel}
                                    disabled={isSaving}
                                >
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={isSaving}>
                                    {isSaving ? 'Guardando...' : 'Crear cliente'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
